// extracted by mini-css-extract-plugin
export default {"GreenTickBulletContainer":"GreenTickBullet_GreenTickBulletContainer__D6l6Y","GreenTick":"GreenTickBullet_GreenTick__J+r53"};